import { initContract } from "@ts-rest/core"
import { CreatePartnerInputSchema, CreatePartnerOutputSchema } from "./partners.schemas"

const c = initContract()

export const partnersRoutes = c.router(
  {
    createPartnerAccount: {
      method: 'POST',
      path: '/workflows/create-partner',
      body: CreatePartnerInputSchema,
      responses: {
        200: CreatePartnerOutputSchema,
      },
    },
  }
)
